import { Link } from "react-router-dom";
import { MapPin, Calendar, ArrowRight } from "lucide-react";
import { Reveal, Eyebrow, SectionTitle } from "./shared";
import { useSite } from "../../context/SiteContext";
import { imgUrl, optImg } from "../../lib/api";

export default function WeddingsSection() {
  const { weddings } = useSite();
  if (!weddings.length) return null;

  return (
    <section id="casamentos" className="py-20 lg:py-28 bg-warmwhite" data-testid="weddings-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-wrap items-end justify-between gap-6">
          <div className="max-w-2xl">
            <Reveal>
              <Eyebrow>Casamentos celebrados</Eyebrow>
              <SectionTitle>Histórias que tive a alegria de celebrar</SectionTitle>
            </Reveal>
          </div>
          <Reveal delay={0.15}>
            <Link
              to="/casamentos-realizados"
              data-testid="weddings-view-all"
              className="inline-flex items-center gap-2 text-sm font-semibold tracking-wide text-olive hover:text-golddark transition-colors border-b-2 border-gold/40 hover:border-gold pb-1"
            >
              VER TODOS OS CASAMENTOS <ArrowRight className="w-4 h-4" />
            </Link>
          </Reveal>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-7">
          {weddings.slice(0, 3).map((w, i) => (
            <Reveal key={w.id} delay={i * 0.12}>
              <Link
                to={`/casamentos-realizados/${w.slug}`}
                className="group block"
                data-testid={`wedding-card-${w.slug}`}
              >
                <div className="overflow-hidden rounded-2xl gold-frame">
                  <img
                    src={optImg(w.cover, 900)}
                    alt={`Casamento de ${w.couple}`}
                    className="w-full aspect-[4/5] object-cover transition-transform duration-700 group-hover:scale-105"
                    loading="lazy"
                  />
                </div>
                <h3 className="mt-5 text-2xl font-serif text-ink group-hover:text-golddark transition-colors">
                  {w.couple}
                </h3>
                <div className="mt-2 flex flex-wrap gap-x-4 gap-y-1 text-xs uppercase tracking-[0.15em] text-cocoa">
                  <span className="inline-flex items-center gap-1.5">
                    <Calendar className="w-3.5 h-3.5 text-gold" /> {w.date_display}
                  </span>
                  <span className="inline-flex items-center gap-1.5">
                    <MapPin className="w-3.5 h-3.5 text-gold" /> {w.city}
                  </span>
                </div>
                <p className="mt-2 text-sm font-light text-stone2">{w.venue}</p>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
